export const TOGGLE_CART_DRAWER = 'TOGGLE_CART_DRAWER';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const CLEAR_CART = 'CLEAR_CART';
